import { render, staticRenderFns } from "./GroupsForSurveyEditModal.vue?vue&type=template&id=5f9a7536"
import script from "./GroupsForSurveyEditModal.vue?vue&type=script&lang=ts"
export * from "./GroupsForSurveyEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports